import { ActionIcon } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useRouterState } from '@tanstack/react-router';
import { IconHelp } from '@tabler/icons-react';
import { HelpDrawer } from './HelpDrawer';

/** Shell.tsx header integration point: a single help button present on every
 * authenticated screen, opening the HelpDrawer scoped to whatever route is
 * currently active (see helpMap.ts for the route → section mapping). */
export function HelpButton() {
  const [opened, { open, close }] = useDisclosure(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <>
      <ActionIcon
        variant="subtle"
        onClick={open}
        aria-label="Help for this page"
        aria-haspopup="dialog"
        aria-expanded={opened}
      >
        <IconHelp size={18} />
      </ActionIcon>
      <HelpDrawer pathname={pathname} opened={opened} onClose={close} />
    </>
  );
}
